export default __webpack_public_path__ + "static/media/광주.bb2e7c49.svg";